// Simple content for demo
module.exports = {
  label: 'Skip to main content',
  href: '#top',
};
